import { render, staticRenderFns } from "./about-icon.vue?vue&type=template&id=b8d246b8&functional=true&"
import script from "./about-icon.vue?vue&type=script&lang=js&"
export * from "./about-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports